import { getOrderData } from './helpers/getOrderData';
import { baseUrl, secrets } from '../../../globalVars/data';

import {
  doc,
  DocumentReference,
  runTransaction,
  updateDoc,
} from 'firebase/firestore';
import { setCtDataError, setErrorTrue } from './helpers/setCtDataError';
import { firestoreOutFlax } from '../../functions/firebase/firebase';
import { updateDocTool } from '../../functions/firebase/updateDoc';
import { argSel, getCtData, goTo, setData } from '../../project';
import { setDocTool } from '../../functions/firebase/setDoc';
import { TMergedLocalBikes } from '../mergeLocationBikes';
import { createCustomer } from './createCustomer';
import { checkoutPath } from './helpers/paths';
import { asyncFn } from './asyncFn';
import { errFnc } from '.';

type Tprops = {
  args: any;
  pass: {
    ipt1: any[];
    ipt2: string;
    ipt3: any[];
  };
};

export const payAndSetFireBase = async (props?: Tprops) => {
  console.log('Gerando Pagamento PIX...');
  const newCustomer = !!getCtData('all.userData.customerId');

  // --------- Check IF is A New Pagar.Me Customer
  if (!newCustomer) await createCustomer();

  // ---------- Get CtData
  const processedData = getOrderData('pix');
  console.log('PIX', { processedData });

  // ---------- EndPoint
  const url = baseUrl + '/orders';

  // ---------- Headers
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Basic ${secrets.sk}`);
  myHeaders.append('Content-Type', 'application/json');

  console.log('HEADERS:', myHeaders);

  // ---------- Body
  const raw = JSON.stringify(processedData); // ctData REAL DATA
  // const raw = JSON.stringify(templateOrder); // Template

  // ---------- Request Config
  const reqConfig = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  // ---------------------------
  // ----------- SET CALL API --
  // ---------------------------
  console.log('ANTES DA CHAMADA PIX', reqConfig);
  const callRequest = await asyncFn(url, reqConfig).catch(errFnc);

  const res = await callRequest.json();
  console.log('DEPOIS DA CHAMADA PIX', res);

  const condStop = setCtDataError(res, callRequest.status);

  // ----- check IF Stop Process
  if (condStop !== 'follow') return;

  // ---------------------------
  // ----- check IF ERROR / STOP
  // ---------------------------
  const condShow = getCtData('all.apis.msgs.condShow');
  const condError = condShow === 'true';

  if (condError)
    return console.log(
      'Depois do Fetch - PIX - createOrder - PROMISE',
      condError,
      callRequest,
    );

  // ----------------------
  // ----- check IF SUCCESS
  // ----------------------
  if (!condError) {
    const css1 =
      'color: #7c0046; background-color: #99df00; font-size: 11px; font-weight: bold; padding: 2px 6px; border-radius: 3px';
    console.log('%ccreateOrder - PIX - SUCCESS!!!', css1, res);

    // const qrCode = res.charges[0]?.last_transaction?.qr_code; //  SVG
    const qrCodeUrl = res.charges[0]?.last_transaction?.qr_code_url; // Url pra Imagem

    setData({ path: 'sc.B4.currData.checkout.paymentData', value: res });
    setData({
      path: 'sc.B4.currData.checkout.timer',
      value: { isRunning: 'waiting' },
    }); // Somente no PIX Resetar Timer
    setData({ path: 'sc.B4D.currData.QRCodeUrl', value: qrCodeUrl });

    goTo('QrCodePay');

    // ------------------------------------
    // ------ CREATE NEW RENT DOCUMENT ----
    // -------------------------------------
    const fireInit = getCtData('all.fireInit');
    const passProps1 = {
      fbInit: [fireInit],
      arrRefStrings: ['rents'],
      arrPathData: ['sc.B4.currData.checkout'],
      arrFuncs: [],
    };

    await setDocTool({ args: {}, pass: passProps1 });

    return res;
  }
};

export const createOrderPIX = async (props?: Tprops) => {
  let bikesList: TMergedLocalBikes[] = getCtData(checkoutPath + '.bikesList');
  const currLocationId = getCtData('sc.B4.currData.checkout.locationId');
  console.log({ bikesList });

  const docsToUpdate: DocumentReference[] = [];

  try {
    // Etapa 1: apenas valida se as bikes estão disponíveis (não faz update ainda)
    await runTransaction(firestoreOutFlax, async transaction => {
      for (const currBike of bikesList) {
        for (const currID of currBike.allLocalIds) {
          const ref = doc(
            firestoreOutFlax,
            'locations',
            currLocationId,
            'localBikes',
            currID,
          );

          const snap = await transaction.get(ref);
          if (!snap.exists()) throw new Error(`Bike ${currID} não existe`);

          const data = snap.data();
          if (data.status !== 'available') {
            throw new Error(
              `Bike ${
                currBike.modelName ?? currID
              } já foi alugada por outra pessoa.`,
            );
          }

          docsToUpdate.push(ref);
        }
      }
    });

    // Etapa 2: pagamento
    const res = await payAndSetFireBase(props);
    if (!res) throw new Error('Pagamento não confirmado');

    // Etapa 3: após pagamento bem-sucedido, atualiza status das bikes
    const arrPromises = docsToUpdate.map(ref =>
      updateDoc(ref, { status: 'unavailable' }),
    );

    await Promise.all(arrPromises);
    console.log('Status das bikes atualizado para "unavailable" com sucesso');
  } catch (err: any) {
    console.error('Erro no fluxo PIX:', err.message);
    setErrorTrue(err.message);
    setData({ path: 'all.toggles.loaderPurchase', value: null });
    return;
  }
};
